import { ArrowLeftOutlined, CheckCircleFilled, SaveOutlined, UploadOutlined } from '@ant-design/icons'
import { Button, Card, Col, Form, message, Row, Select, Space, Table, Typography, Upload, Input, DatePicker, TimePicker, Transfer, Flex, Image} from 'antd'
import { useEffect, useRef, useState } from 'react'
import * as XLSX from 'xlsx';
import api from '../../API';
import pdfLogo from '../../assets/images/pdfIcon.svg'
import { useLocation, useNavigate, Link } from 'react-router-dom';
import dayjs from 'dayjs';

const contactColumns = [
    {
      title: "Contact Name",
      dataIndex: "display_name",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    }
];

function Payroll() {
    const navigate = useNavigate();
    const location = useLocation();
    const [contacts, segments, segmentsAndContacts, oaccounts] = location.state;
    const [form] = Form.useForm()
    const [payroll, setPayroll] = useState([]);
    const [loading, setLoading] = useState({spin: false, contact: false, btn: false,  upload: false, table: false});
    const [options2, setOptions2] = useState([]);
    const [options3, setOptions3] = useState([]);
    const [payrollColumns, setPayrollColumns] = useState([]);
    const [targetKeys, setTargetKeys] = useState([]);
    const [preView, setPreView] = useState(null);
    const [selectedContactIds ,setSelectedContactIds] = useState([]);
    const [selectedOAId ,setSelectedOAId] = useState(null);
    const filterContactsByOAID= useRef([]);
    const [contactData, setContactData] = useState([]);
    const now = useRef((new Date()).toLocaleDateString('en-CA'));
    const user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        setLoading({...loading, spin: true, contact: true});
        setOptions2([{value: 'All', label: 'All'}, ...segments.map(({id: value, segmentName: label}) => ({value, label}))]);
        setOptions3(oaccounts.map((oaccount, i) => ({ value: i, label: oaccount.accountName})))
        filterContactsByOAID.current=contacts.concat();
        setLoading({...loading, spin: false, contact: false});
    }, [])

    function handleSelectedOAAccount (selectedValue) {
      filterContactsByOAID.current = contacts.filter(contact => contact.OAId === oaccounts[selectedValue].OAId)
      setContactData(filterContactsByOAID.current);
      setSelectedOAId(oaccounts[selectedValue].OAId);
    }

    function handleSelectedSegment(selectedValue) {
        if(selectedValue === 'All') {
          setContactData(filterContactsByOAID.current);
          setSelectedContactIds(segmentsAndContacts.map((obj) =>  obj.contactId))
        } else {
          let contactIds = segmentsAndContacts.reduce((prevArr, obj) => obj.segmentId === selectedValue? [...prevArr, obj.contactId]: prevArr, [])
          setContactData(filterContactsByOAID.current.filter(obj=> contactIds.includes(obj.key)));
          setSelectedContactIds(contactIds);
        }
    }

    const handleUpload = async ({ file }) => {
      try {
        setLoading((prevObj) => ({ ...prevObj, upload: true, table: true }));
        const arrayBuffer = await file.originFileObj.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const columns = rows[0].map((column) => ({
          title: column,
          dataIndex: column,
        }));
        const data = rows.slice(1).map((row, i) => ({
          key: i,
          ...row.reduce((obj, val, index) => {
            obj[columns[index].dataIndex] = val;
            return obj;
          }, {}),
        }));
        const deliveryPhones = data.map(obj => {
          if(obj[columns[1].dataIndex]?.toString().slice(0,2) !== '84' && obj[columns[1].dataIndex]?.toString()?.length === 9) return '84'+ obj[columns[1].dataIndex];
          if(obj[columns[1].dataIndex]?.toString().at(0) === '0' && obj[columns[1].dataIndex]?.toString()?.length === 10) return '84'+ obj[columns[1].dataIndex]?.slice(1);
          return obj[columns[1].dataIndex]?.toString();
        });
        filterContactsByOAID.current = contacts.filter(contact => deliveryPhones.includes(contact?.phone) && contact.OAId === selectedOAId);
        let contactFilterBySegment = selectedContactIds.length > 0? filterContactsByOAID.current.filter(obj=> selectedContactIds.includes(obj.key)): filterContactsByOAID.current;
        setContactData(contactFilterBySegment);
        form.setFieldValue('contactIds', [])
        setPreView(data[0])
        setPayrollColumns(columns);
        setPayroll(data);
      } catch (error) {
        throw error;
      } finally {
        setLoading((prevObj) => ({ ...prevObj, upload: false, table: false }));
      }
    };

    function getMessage (token) {
        try {
          let messageBody = JSON.stringify({
              message: {
                attachment: {
                  type: "file",
                  payload: {
                    token 
                  }
                }
            }})
          return messageBody;
        } catch (error) {
          throw error;
        }
      }

    async function handleSubmit(values) {
      let cmpId = null;
      try {
        if(payroll.length) {
          setLoading({...loading, btn: true})
          const {OAAccountIndex, campaignName, startDate, startTime, contactIds} = values;
          const sendContacts = contacts.reduce((prevArr, {key, zaloUid, phone}) => contactIds.includes(key)? [...prevArr, {zaloUid, phone}] :  prevArr, []);
          const fileTokens = await api.exportPdfs({payroll, columns: payrollColumns, accountId: oaccounts[OAAccountIndex]?.id});
          let campaignObj = {
            campaignName, 
            startDate: (new Date(startDate)).toLocaleDateString('en-CA'), 
            startTime: (new Date(startTime)).toLocaleTimeString('it-IT'),
            template_type: "consultant",
            msgVolume: sendContacts.length,
            templateId: 1,
            createDate: now.current,
            userId: user?.userId,
            accountId: oaccounts[OAAccountIndex].id,
            OAId: oaccounts[OAAccountIndex].OAId
          };
          const responseCmp = await api.create_new_campaignpayrolls(campaignObj);
          cmpId = responseCmp.result.insertId;
          const messageArr = sendContacts.map(({zaloUid, phone: phoneNumber}) =>{
            const fileToken = fileTokens[phoneNumber];
            let msg = {
              campaignId: cmpId,
              accountId: oaccounts[OAAccountIndex].id,
              OAId: oaccounts[OAAccountIndex].OAId,
              userId: user?.userId,
              zaloUid,
              consultingTplId: 1,
              phoneNumber,
              messageBody: getMessage(fileToken),
              insertAt: (new Date()).toLocaleDateString('en-CA')
            }
            return msg;
          });
            await Promise.all(messageArr.map(msg => api.create_new_messagespayrolls(msg)));
            message.success(responseCmp.message);
            message.success("File uploaded successfully");
            navigate(`/payroll`, { replace: true });
        } else message.error('Payroll table cannot be empty!');
      } catch (error) {
          message.error(error.message);
          if(cmpId !== null) api.delete_campaignpayrolls_byId(cmpId).catch((err) => message.error(err.message))
      } finally {
          setLoading({...loading, btn: false})
      }
    }

    return (
        <Card 
            style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
            title={
            <Space>
                <Link to={`/payroll`} replace={true}>
                        <Button style={{width: 50}} icon={<ArrowLeftOutlined />}></Button>
                </Link>
                <Typography.Title level={5} style={{margin: 0}}>Create new campaign to send payroll</Typography.Title>
            </Space>
            }
            loading={loading.spin}
        >
          <Form name="campaignform" label="campaign form" layout="vertical" form={form} onFinish={handleSubmit}>
            <Row gutter={16}>
              <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Form.Item label='OA Account'
                          name="OAAccountIndex"
                          rules={[{required: true, message: 'The OA Account cannot be empty'}]}>
                  <Select 
                    options={options3} 
                    placeholder="Select OA Account" 
                    showSearch
                    onChange={handleSelectedOAAccount}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
                <Form.Item label='Name'
                           name='campaignName'
                           rules={[{required: true, message: 'The campaign name cannot be empty'}]}>
                  <Input placeholder="Enter campaign name..." />
                </Form.Item>
                <Space styles={{item: {width: '100%'}}} style={{width: '100%'}}>
                  <Form.Item label='Schedule Date'
                            name='startDate'
                            rules={[{required: true, message: 'The date cannot be empty'}]}>
                    <DatePicker style={{width: '100%'}} disabledDate={(current) => current && current < dayjs().startOf('day')}/>
                  </Form.Item>
                  <Form.Item label='Schedule Time'
                            name='startTime'
                            rules={[{required: true, message: 'The time cannot be empty'}]}>
                    <TimePicker format="HH:mm" style={{width: '100%'}}/>
                  </Form.Item>
                </Space>
                <Form.Item  label="Payroll"
                            required
                            rules={[{required: true, message: 'Payroll cannot be empty'}]}>
                    <Space direction='vertical' style={{width: '100%'}}>
                        <Upload
                            accept='.xlsx'
                            customRequest={({onSuccess})  => onSuccess('ok')}
                            style={{position: "absolute"}}
                            onChange={handleUpload}
                            itemRender= {() => null}
                            loading={loading.upload}
                        >
                            <Button type='primary' icon={<UploadOutlined />} >Upload Excel</Button>
                        </Upload>
                        <Table  
                            bordered
                            scroll={{x: 1200}}
                            columns= {payrollColumns}
                            style={{width: '100%'}} 
                            dataSource={payroll}
                            loading={loading.table}
                            pagination={{
                                position: ["bottomCenter"],
                                showSizeChanger: false, // Disable page size changer
                                pageSize: 10, 
                                showTotal: () => `Total: ${payroll.length} items`
                            }}
                        />
                    </Space>
                </Form.Item>
                <Form.Item label="Choose segments">
                  <Select 
                    options={options2} 
                    placeholder="Select segment" 
                    onChange={handleSelectedSegment} popupMatchSelectWidth={false}
                    showSearch 
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                  />
                </Form.Item>
                <Form.Item  label="Choose contacts" 
                  name='contactIds' 
                  rules={[{required: true, message:'Contacts must be selected'}]}
                  style={{width: '100%'}}
                  valuePropName="targetKeys" 
                  getValueFromEvent={(nextTargetKeys) => nextTargetKeys}>
                  <Transfer
                    titles={['Source', 'Target']}
                    dataSource={contactData.map(contact => ({ key: contact.key, display_name: contact.display_name, phone: contact.phone}))}
                    targetKeys={targetKeys}
                    showSearch
                    showSelectAll={false}
                    listStyle={{width: '40%'}}
                    onChange={(nextTargetKeys)=>{setTargetKeys(nextTargetKeys)}}
                    filterOption={(input, item) => ((item.phone && String(item.phone).includes(input)) || item.zaloUid?.includes(input))}>
                    {({
                      filteredItems,
                      onItemSelect,
                      onItemSelectAll,
                      selectedKeys: listSelectedKeys,
                    }) => {
                      const rowSelection = {
                        onChange(selectedRowKeys) {
                          onItemSelectAll(selectedRowKeys, 'replace');
                        },
                        selectedRowKeys: listSelectedKeys,
                        selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
                      };
                      return (
                        <Table
                          loading= {loading.contact}
                          rowSelection={rowSelection}
                          columns={contactColumns}
                          dataSource={filteredItems}
                          size="small"
                          scroll={{x: '40%'}}
                          onRow={({ key}) => ({
                            onClick: () => {
                              onItemSelect(key, !listSelectedKeys.includes(key));
                            },
                          })}
                          pagination={{
                            position: ["bottomCenter"],
                            showSizeChanger: false, // Disable page size changer
                            pageSize: 5
                          }}
                        />
                      );
                    }}
                  </Transfer>
                </Form.Item>
              </Col>
              <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Card 
                  style={{width: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
                  size='small'
                  title="Preview PDF"
                  actions={preView && [
                    <Flex align='center' style={{maxHeight: 70}}>
                      <div style={{paddingLeft: 3, flex: 0.6}}>
                          <Image width='50%' src={pdfLogo} alt='Anh' preview={false} />
                      </div>
                      <Flex vertical style={{flex: 3}} align='start' justify='space-between'>
                          <h4 style={{margin: 2, color: 'black'}}>salary_{preView[payrollColumns[3].dataIndex]}.pdf</h4>
                          <p style={{margin: 2, color: '#808080'}}>PDF - 17KB</p>
                          <Space styles={{item: {color: '#66CC66'}}}>
                            <CheckCircleFilled />
                            <div>Đã có trên mây</div>
                          </Space>
                      </Flex>
                  </Flex>
                  ]}
                >
                  { preView && 
                  <>
                    <Typography.Title level={4} style={{margin: 0}}>Phiếu lương</Typography.Title>
                    <Typography.Text>{preView[payrollColumns[2].dataIndex]}</Typography.Text>
                    <table style={{width: '100%', marginTop: 20, borderCollapse: 'collapse'}}>
                      {payrollColumns?.slice(3).reduce((prevArr, column, i, columnArr) => {
                        if(prevArr[prevArr.length -1].length < 4) {
                          prevArr[prevArr.length -1].push({ text: column.title, style: {border: '1px solid #333', fontWeight: 'bold', padding: 5}}, { text: preView[column.dataIndex], style: {border: '1px solid #333', padding: 5}});
                          return prevArr;
                        }
                        else {
                          if(i === columnArr.length - 1) {prevArr.push([{ text: column.title, style: {border: '1px solid #333', fontWeight: 'bold', padding: 5} }, { text: preView[column.dataIndex], style: {border: '1px solid #333', padding: 5}} , {text: '', style: {border: '1px solid #333', fontWeight: 'bold', padding: 5}}, {text: '', style: {border: '1px solid #333', padding: 5}}]);	}
                          else prevArr.push([{ text: column.title, style: {border: '1px solid #333', fontWeight: 'bold', padding: 5}}, { text: preView[column.dataIndex], style: {border: '1px solid #333', padding: 5}}]);
                          return prevArr;
                        }
                      },[[]]).map((row,i) => (<tr key={i}>{row.map(column => (<td style={column.style}>{column.text}</td>))}</tr>))}
                    </table>
                  </>}
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item style={{marginTop: 10}}>
                  <Button type="primary" htmlType="submit" loading={loading.btn} icon={<SaveOutlined/>}>Save</Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
    )
}

export default Payroll
